import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpError } from '@rd/types/http-error.type';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as actions from '../store/actions/points-transfer.actions';
import {
  getTransferPointsError,
  getTransferPointsFail,
  getTransferPointsFormState,
  getTransferPointsLoading,
  getTransferPointsSuccess,
} from '../store/selectors/points-transfer.selectors';
import { PointsTransferFormData } from '../types';

@Injectable({
  providedIn: 'root',
})
export class PointsTransferFacade {
  constructor(private store: Store) {}

  transferPointsForm$ = this.store.select(getTransferPointsFormState);

  transferPointsLoading$: Observable<boolean> = this.store.select(
    getTransferPointsLoading,
  );

  transferPointsSuccess$: Observable<boolean> = this.store.select(
    getTransferPointsSuccess,
  );

  transferPointsFail$: Observable<boolean> = this.store.select(
    getTransferPointsFail,
  );

  transferPointsError$: Observable<HttpError | null> = this.store.select(
    getTransferPointsError,
  );

  getCheckoutFormData(
    loyaltyProgramId: string,
  ): Observable<PointsTransferFormData | null> {
    return this.transferPointsForm$.pipe(
      map((formState) => formState[loyaltyProgramId]),
    );
  }

  submitPointsTransferForm(data: {
    loyaltyProgramId: string;
    formData: PointsTransferFormData;
  }): void {
    this.store.dispatch(actions.SubmitPointsTransferForm(data));
  }

  transferPoints(data: {
    loyaltyProgramId: string;
    formData: PointsTransferFormData;
  }): void {
    this.store.dispatch(actions.TransferPoints(data));
  }
}
